import { render, staticRenderFns } from "./KeyValueEditor.vue?vue&type=template&id=07da475c&scoped=true&"
import script from "./KeyValueEditor.vue?vue&type=script&lang=js&"
export * from "./KeyValueEditor.vue?vue&type=script&lang=js&"
import style0 from "./KeyValueEditor.vue?vue&type=style&index=0&id=07da475c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da475c",
  null
  
)

export default component.exports